export function isMobile() {
  return window.outerWidth < 500;
}
